<template>
  <div>
    <div class="h-topo_pw2" v-show="see" :style="PositionXY">
      <!-- <div class="h-topo_pw"> -->

      <div class="h-topo_pw_top">
        <div class="h-topo_wytb1">
          <span :class="['icon hero-icon '+icon+ ' '+online]"></span>
        </div>
        <div class="h-topo_wytb_topwz" :title='devInfo.name'>{{$t('Topo.devName')}}：{{devInfo.name}}</div>
        <div class="h-topo_wytb2">
           <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-Expand"></span>
        </div>
      </div>
      <div class="h-topo_pw_bottom" v-if="seeBottom">
        <div class="h-topo_wybox">
          <div class="h-topo_wytb3"></div>
          <div class="h-topo_wytb3">
            <span class="e-btn-icon icon hero-icon hero-icon-detailed"></span>
          </div>
          <div class="h-topo_xq">{{$t('Topo.serveDetail')}}</div>
          <div class="h-topo_wytb_wz">
            <table class="h-topo_tableheight">
              <tr>
                <td>{{$t('Topo.devID')}}: {{devInfo.id}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.devType')}}: {{devInfo.name}}</td>
              </tr>
              <tr v-if="seeDevAttriTrunk">
                <td>{{$t('Topo.devAttriTrunk')}}: {{devInfo.softwareVersion}}</td>
              </tr>
              <tr>
                <td>{{$t('Topo.devSoftVersion')}}: {{devInfo.displaySoftwareVersion}}</td>
              </tr>
              <tr v-for="(item,i) in equipmentIPList" :key="i">
                <td>
                <table >
                <tr>
                  <td>{{$t('Topo.devIp')}}: {{item.ip}}</td>
                </tr>
                <tr>
                  <td class="h-topo-padding">{{$t('Topo.devPort')}}: {{item.port}}</td>
                </tr>
                </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="h-topo_btnbox">
          <button class="e-primary e-btn" @click="alarmShowOperation">{{$t('Alarm.alarm')}}</button>
        </div>
      </div>
    </div>
    <!-- “告警弹窗展示” -->
    <CustomDialog ref="oprDialog" :element="oprSetDialog.element" :styles="oprSetDialog.styles">
      <template v-slot:dialog-content>
        <AlarmShowDialog ref='alarmDetailDialog'></AlarmShowDialog>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from "../../components/common/CustomDialog";
import AlarmShowDialog from "../../components/topoconfig/AlarmShowDialog";
import { EventBus } from '../../plugins/eventBus';

export default {
  name: "PanelBoardShow",
  components: {
    CustomDialog,
    AlarmShowDialog
  },
  data() {
    return {
      alarmDetailObj: { id: this.id},
      //-- view to left or right
      PositionXY: '',
      typeData: [],
      typeCode: "",
      icon: "",
      online: "",
      devInfo: {},
      equipmentIPList: [],
      see: false,
      seeBottom: false,
      id: "",
      type: "",
      trunkName: "",
      seeDevAttriTrunk: false,
      trunkList: [],
      trunkFields: { value: "clusterId", text: "trunkName" },
      oprSetDialog: {
        element: {
          title: this.$t("Alarm.alarm"),
          target: "#app",
          isClose: true,
          refName: "oprSetDia",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: this.$t("Alarm.confirm") }
            }
          ]
        },
        styles: {
          width: "810px",
          height: "760px",
          model: true,
          visible: false,
        }
      }
    };
  },
  props: ["alarmShowObj"],
  methods: {
    panelBoardGetData() {
      this.axios
        .get(`/lte/ems/topo/device/devInfoPanelDetail/${this.id}`)
        .then(response => {
          if (response.data.errorCode === "SUCCESS") {
            this.devInfo = response.data.resultVal;
            console.log("设备",this.devInfo)
            this.equipmentIPList = this.devInfo.equipmentIPList;

        if (this.type === 10003 && null!==this.devInfo.clusterId) {
          this.seeDevAttriTrunk = true;
        }
          }
        });
    },

    // 去后台查设备类型
    queryDevType(typeCode) {
      const This = this;
      const params = {};
      This.$axios.get("/lte/ems/topo/device/devType", params).then(response => {
        if (response.data === undefined) {
          return;
        }
        if (response.data.errorCode === "SUCCESS") {
          This.typeData = response.data.resultVal;
          console.log("typeData",This.typeData)
          for (let index in This.typeData) {
            if (This.typeData[index].typeCode == typeCode) {
              this.typeCode = This.typeData[index].nameKey;
              this.icon = This.typeData[index].icon;
            }
          }
        } else if(response.status === 401) {
          EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
        } else {
          This.typeData = [];
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
      });
    },
    click() {
      this.seeBottom = !this.seeBottom;
      this.see = !this.see;
    },

    alarmShowOperation() {
      var alarmId=this.id;
      let ids = [alarmId];
      this.$axios.get(`/lte/ems/topo/netElement/${alarmId}`).then(response => {
        if (!response.data) {
          return;
        }
        if (response && response.status === 200 && response.data.errorCode === "SUCCESS") {
          if (response.data && response.data.resultVal.length > 0) {
            ids = ids.concat(response.data.resultVal);
          }
        } else if(response.status === 401) {
          EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
        this.$refs.alarmDetailDialog.beforeMount(ids);
        this.$refs.oprDialog.show();
      });
    },
    dialogHide() {
      this.$refs.oprDialog.clear();
      this.$refs.oprDialog.close();
    }
  },

  mounted() {},
  watch: {
    //父子动态传值
    alarmShowObj: {
      handler: function(newVal, oldVal) {
        this.see = newVal.seeObj;
        this.seeBottom = newVal.seeBottomObj;
        this.id = newVal.idObj;
        this.type = newVal.typeObj;

        if(newVal.onlineObj===1)
        	this.online='h-pm-iconOnline';
        else if(newVal.onlineObj===0)
        	this.online='h-pm-iconOffline';

        this.PositionXY = newVal.PositionXY;
        this.seeDevAttriTrunk = false;
        this.panelBoardGetData();
        this.queryDevType(this.type);
      },
      deep: true
    }
  }
};
</script>
